<template>
  <div class="platform-view-container">
    <div v-if="loadingData" class="loader-wrapper">
      <div class="loader">
        <div class="loader-icon"></div>
      </div>
    </div>
    <div v-show="!loadingData" class="course-detail position-relative">
      <div class="banner-card-header">
        <!-- Botón Volver dentro del banner -->
        <button
          class="btn btn-sm bg-gradient-fvf btn-volver"
          @click.prevent="returnUrl"
          type="button"
        >
          Volver
        </button>
        <img
          v-if="!isLoading && isBanner"
          :src="form_update.url_banner"
          alt="banner"
          class="image-fluid"
        />
        <div v-else class="d-flex justify-content-center p-4">
          <img
            src="../../core_assets/img/ccdlogolite.png"
            alt="..."
            class="img-fluid"
            style="height: 200px; width: auto"
          />
        </div>
        <div class="banner-gradient-overlay"></div>
      </div>

      <!-- Contenido con fondo -->
      <div class="platform-content-wrapper">
        <!-- Tabs -->
        <div class="tabs-container px-4 pt-3">
          <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'info' }"
            @click="activeTab = 'info'"
          >
            INFORMACIÓN
          </button>
          <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'ciudades' }"
            @click="activeTab = 'ciudades'"
          >
            CIUDADES DISPONIBLES
          </button>
        </div>

        <!-- Tab Content: INFO -->
      <!-- Tab Content: INFO -->
      <div v-show="activeTab === 'info'" class="tab-info p-4">
        <!-- Título -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2 class="platform-title text-white mb-0">{{ form_update.name }}</h2>
          <span v-if="registrationStatusText" class="badge" :class="registrationStatusClass" style="font-size: 0.9rem; padding: 0.5rem 1rem;">
            {{ registrationStatusText }}
          </span>
        </div>
        
        <!-- Descripción (col-12) -->
        <div class="col-12 mb-4">
          <p class="platform-description text-white text-justify" v-html="formatDescriptionText(form_update.description)"></p>
        </div>

        <!-- Row de inputs informativos -->
        <div class="row g-3 mb-4">
          <!-- Fecha de inicio -->
          <div class="col-6 col-md-3" v-if="form_update.date_start">
            <div class="info-input">
              <span class="info-label">Fecha de inicio: {{ formatDate(form_update.date_start) }}</span>
            </div>
          </div>
          
          <!-- Duración -->
          <div class="col-6 col-md-3" v-if="form_update.duration">
            <div class="info-input">
              <span class="info-label">Duración: {{ form_update.duration }}</span>
            </div>
          </div>



        </div>

        <!-- Detalles esenciales -->
        <h6 class="text-white mb-3">Detalles esenciales</h6>
        
        <div class="row g-3">
          <!-- Columna izquierda con inputs -->
          <div class="col-12 col-md-8">
            <div class="row g-3">
              <!-- Licencias -->
              <div class="col-6" v-if="hasLicenses">
                <div class="info-input">
                  <span class="info-label">Licencia requerida: {{ getLicensesText }}</span>
                </div>
              </div>

              <!-- Tipo de plataforma -->
              <div class="col-6" v-if="form_update.type_platform">
                <div class="info-input">
                  <span class="info-label">Modalidad: {{ form_update.type_platform.name }}</span>
                </div>
              </div>

              <!-- Categoría -->
              <div class="col-6" v-if="form_update.type_platform_category">
                <div class="info-input">
                  <span class="info-label">Tipo de curso: {{ form_update.type_platform_category.name }}</span>
                </div>
              </div>

              <!-- Especialidad -->
              <div class="col-6" v-if="form_update.type_platform_speciality">
                <div class="info-input">
                  <span class="info-label">Disciplina: {{ form_update.type_platform_speciality.name }}</span>
                </div>
              </div>

              <!-- Instructores -->
              <div class="col-12" v-if="form_update.instructors">
                <div class="info-input">
                  <span class="info-label">Instructores: {{ form_update.instructors }}</span>
                </div>
              </div>

              <!-- Requisitos -->
              <div class="col-12" v-if="form_update.requires">
                <h6 class="text-white mb-2">Requisitos</h6>
                <div class="info-input info-input-multiline">
                  <p class="mb-0 mt-1" v-html="formatRequiresText(form_update.requires)"></p>
                </div>
              </div>

              <!-- URL -->
              <div class="col-12" v-if="form_update.url && id_type_status == 3 && id_type_status_payment == 3">
                  <span class="info-label">
                  <button @click.prevent="accessPlatform" class="btn btn-fvf-access position-relative overflow-hidden w-100 py-3">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span class="position-relative z-index-1 text-uppercase fw-bold letter-spacing-1">
                      Acceder al enlace de la plataforma
                    </span>
                  </button>
                  </span>
                </div>
            </div>
          </div>

          <!-- Columna derecha con video -->
          <div class="col-12 col-md-4" v-if="form_update.url_video">
            <div class="video-container">
              <iframe 
                v-if="getVideoEmbedUrl(form_update.url_video)"
                :src="getVideoEmbedUrl(form_update.url_video)"
                name="video-iframe"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="video-player"
              ></iframe>
              <div v-else class="video-placeholder">
                <iconify-icon icon="lucide:play-circle" class="video-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Content: CIUDADES -->
      <div v-show="activeTab === 'ciudades'" class="tab-ciudades p-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h5 class="section-title text-white mb-0">Selecciona una ciudad para inscribirte</h5>
          <div class="d-flex gap-2">
            <button 
              v-if="canPay"
              class="btn btn-success"
              @click.prevent="openModalPayment"
            >
              <span class="btn-text-label">PAGAR</span>
            </button>
            <button 
              v-if="!canPay"
              class="btn btn-golden-hover"
              :disabled="!selectedOfferId || (alreadyRegistered && id_type_status != 2)"
              @click.prevent="postulateMe"
            >
              <span class="btn-text-label">
                {{ id_type_status == 2 ? 'VOLVER A POSTULARME' : (alreadyRegistered ? 'YA ESTÁS INSCRITO' : 'INSCRIBIRME') }}
              </span>
              <span class="btn-icon-circle">
                <iconify-icon icon="lucide:arrow-up-right" class="icon-initial" />
                <iconify-icon icon="lucide:arrow-right" class="icon-hover" />
              </span>
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="form-label text-white mb-1">Filtrar por estado</label>
            <multiselect
              v-model="selectedState"
              :options="statesWithOffers"
              label="name"
              track-by="id"
              placeholder="Todos los estados"
              :allow-empty="true"
              class="custom-input"
            ></multiselect>
          </div>
        </div>

        <div v-if="loadingOffers" class="text-center py-5">
          <div class="loader-icon mx-auto"></div>
          <p class="text-white mt-3">Cargando ofertas...</p>
        </div>

        <div v-else-if="offers.length === 0" class="text-center py-5">
          <p class="text-white">No hay ofertas disponibles para esta plataforma.</p>
        </div>

        <div v-else class="cities-grid">
          <div 
            v-for="offer in filteredOffers" 
            :key="offer.id" 
            class="city-card"
            :class="{ 'city-card-selected': selectedOfferId === offer.id }"
            @click="selectOffer(offer.id)"
          >
            <h4 class="city-name">{{ offer.cityName || 'Venezuela' }}</h4>
            <div class="city-details">
              <div class="city-detail-item" v-if="offer.quantity">
                <span>Cupos: {{ offer.quantityFormatted || offer.quantity }}</span>
              </div>
              <div class="city-detail-item" v-if="offer.amountFormatted">
                <span>Precio: ${{ offer.amountFormatted }}</span>
                <small class="d-block text-white-50 mt-1">
                  {{ offer.priceType }}
                </small>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Doble botón de postulación / pago al final -->
        <div class="d-flex justify-content-end mt-4">
          <button 
            v-if="canPay"
            class="btn btn-success"
            @click.prevent="openModalPayment"
          >
            <span class="btn-text-label">PAGAR</span>
          </button>
          <button 
            v-if="!canPay"
            class="btn btn-golden-hover"
            :disabled="!selectedOfferId || (alreadyRegistered && id_type_status != 2)"
            @click.prevent="postulateMe"
          >
            <span class="btn-text-label">
              {{ id_type_status == 2 ? 'VOLVER A POSTULARME' : (alreadyRegistered ? 'YA ESTÁS INSCRITO' : 'INSCRIBIRME') }}
            </span>
            <span class="btn-icon-circle">
              <iconify-icon icon="lucide:arrow-up-right" class="icon-initial" />
              <iconify-icon icon="lucide:arrow-right" class="icon-hover" />
            </span>
          </button>
        </div>
      </div>
      </div>

      <!-- MODAL UPLOAD IMAGE -->
      <div
        :class="[
          'custom-modal-payment',
          selectorOpen ? 'modal fade show disable-scroll' : 'modal fade show',
        ]"
        :id="'modalPostulation'"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content p-0">
            <div class="modal-header custom-header">
              <h2 class="modal-title w-100 text-center m-0">Requisitos</h2>
              <button
                type="button"
                class="close custom-close"
                data-dismiss="modal"
                aria-label="Close"
                @click.prevent="closeUploadElement"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-4">
              <form>
                <div class="row">
                  <div class="col-md-12 text-justify">
                    <p v-html="formatRequiresText(form_update.requires)"></p>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-12"
                    v-if="
                      (filesUser && filesUser.length > 0) ||
                      (form_save.url_file && form_save.url_file.length > 0)
                    "
                  >
                    Archivos adjuntos
                  </div>
                  <div class="col-md-12" v-else>Adjunta tus requisitos</div>
                </div>
                <div
                  class="row"
                  v-if="
                    (id_type_status == 1 &&
                      filesUser &&
                      filesUser.length > 0) ||
                    (id_type_status == 2 && filesUser && filesUser.length > 0)
                  "
                  v-for="item in filesUser"
                >
                  <div class="col-md-10 me-0">
                    <a :href="item.url_file" target="_blank">{{ item.name }}</a>
                  </div>
                  <div class="col-md-2">
                    <button
                      type="submit"
                      class="btn btn-sm bg-gradient-fvf-switch"
                      style="
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                      "
                      @click.prevent="deleteFile(item.id)"
                    >
                      <v-icon name="trash" fill="#CE0D0D" size="20px"></v-icon>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <file-pond
                          ref="filePond"
                          name="image"
                          v-model="form_save.url_file"
                          allow-multiple="true"
                          class="w-100 h-100"
                          label-idle="Arrastre o seleccione los archivos"
                        ></file-pond>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button
                        v-if="id_type_status == 0"
                        type="submit"
                        class="btn btn-sm btn-info btn-fill float-right"
                        @click.prevent="postulateWithRequires"
                      >
                        Subir
                      </button>
                      <button
                        v-if="id_type_status == 1 || id_type_status == 2"
                        type="submit"
                        class="btn btn-sm btn-info btn-fill float-right"
                        @click.prevent="uploadFiles"
                      >
                        Subir
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- MODAL PAYMENT REPORT -->
      <div
        :class="[
          'custom-modal-payment',
          selectorOpen ? 'modal fade show disable-scroll' : 'modal fade show',
        ]"
        :id="'modalPayment'"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content p-0" style="overflow: visible !important; border-radius: 15px; border: none;">
            <div class="modal-header custom-header" style="border-radius: 15px 15px 0 0;">
              <h2 class="modal-title w-100 text-center m-0 text-white">Reporte de Pago</h2>
              <button
                type="button"
                class="close custom-close"
                data-dismiss="modal"
                aria-label="Close"
                @click.prevent="closePaymentElement"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- Información de pago -->
            <div
              class="row payment-information-header px-4 py-3 text-white"
              style="background: #351020; margin: 0;"
            >
              <div class="col-12 col-md-6">
                <p class="mb-0 text-white">
                  <strong>Curso: </strong>
                  <span class="text-white">{{ form_update.name }}</span>
                </p>
                <p class="mb-0 text-white">
                  <strong>Inversión: </strong>
                  <span class="text-white">${{ currentAmountFormatted }}</span>
                </p>
                <p class="mb-0 text-white">
                  <strong>Tasa BCV: </strong>
                  <span class="text-white">Bs.{{ bcvRateFormatted }}</span>
                </p>
                <p class="mb-0 text-white">
                  <strong>Total a pagar: </strong>
                  <span class="text-white">Bs.{{ totalPaymentAmountFormatted }}</span>
                </p>
              </div>
              <div
                class="col-12 col-md-6 text-white"
                v-if="form_payment.id_company_bank"
              >
                <p class="mb-0 text-white">
                  <strong>Datos para el pago:</strong>
                </p>
                <p class="mb-0 text-white">
                  <strong>Razón Social :</strong>
                  <span class="text-white">{{ form_payment.id_company_bank.holder_bank }}</span>
                </p>
                <p class="mb-0 text-white">
                  <strong>Nro Cuenta :</strong>
                  <span class="text-white">{{ form_payment.id_company_bank.account }}</span>
                </p>
                <p class="mb-0 text-white">
                  <strong>CI/RIF:</strong>
                  <span class="text-white">{{ form_payment.id_company_bank.dni }}</span>
                </p>
              </div>
            </div>
            <div
              class="modal-body px-4 py-4"
              style="overflow: visible !important; background: white; border-radius: 0 0 15px 15px; height: auto !important; max-height: none !important;"
            >
              <form>
                <div class="row g-2 align-items-end">
                  <div class="col-12 col-md-6 mb-3">
                    <label class="form-label fw-bold text-dark">Banco de destino</label>
                    <multiselect
                      v-model="form_payment.id_company_bank"
                      label="name_bank"
                      :options="companyBank"
                      :searchable="true"
                      placeholder="Banco de destino"
                      class="custom-input"
                    ></multiselect>
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <label class="form-label fw-bold text-dark">Fecha de pago</label>
                    <input v-model="form_payment.date" type="date" class="form-control" />
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <label class="form-label fw-bold text-dark">Moneda</label>
                    <multiselect
                      v-model="form_payment.currency"
                      :options="currencyOptions.map(c => c.code)"
                      :custom-label="opt => currencyOptions.find(c => c.code === opt)?.name || opt"
                      placeholder="Selecciona la moneda"
                      class="custom-input"
                      :allow-empty="false"
                    ></multiselect>
                  </div>
                  <div
                    class="col-12 col-md-6 mb-3"
                    v-if="form_payment.id_company_bank"
                  >
                    <label class="form-label fw-bold text-dark">Banco emisor</label>
                    <multiselect
                      v-model="form_payment.origin_bank"
                      label="name"
                      track-by="id"
                      :options="banks_nationals"
                      :searchable="true"
                      placeholder="Selecciona banco emisor"
                      class="custom-input"
                    ></multiselect>
                  </div>
                  <div
                    class="col-12 col-md-6 mb-3"
                    v-if="form_payment.id_company_bank"
                  >
                    <base-input
                      type="text"
                      label="Referencia"
                      label-class="text-dark fw-bold"
                      placeholder="Referencia"
                      v-model="form_payment.reference"
                      class="custom-input mb-0"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      @input="
                        form_payment.reference = form_payment.reference.replace(
                          /[^0-9]/g,
                          ''
                        )
                      "
                    ></base-input>
                  </div>
                  <div
                    class="col-12 col-md-6 mb-3"
                    v-if="form_payment.id_company_bank"
                  >
                    <base-input
                      type="text"
                      :label="form_payment.currency === 'USD' ? 'Precio de pago ($)' : 'Precio de pago (Bs.)'"
                      label-class="text-dark fw-bold"
                      :placeholder="form_payment.currency === 'USD' ? 'Precio en Dólares' : 'Precio en Bolívares'"
                      v-model="amountWithPrefix"
                      class="custom-input mb-0"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      @keypress="!/[0-9]/.test($event.key) && $event.preventDefault()"
                    ></base-input>
                  </div>
                  <div
                    class="col-12 mb-3"
                    v-if="form_payment.id_company_bank"
                  >
                    <label class="form-label fw-bold text-dark">Captura de pago</label>
                    <file-pond
                      ref="filePondPayment"
                      name="capture"
                      v-model="form_payment.url_image"
                      allow-multiple="true"
                      label-idle="Arrastre o seleccione la captura del pago"
                    ></file-pond>
                  </div>
                  <div class="col-12">
                    <div class="d-grid">
                      <button
                        v-if="form_payment.id_company_bank"
                        type="submit"
                        class="btn custom-btn-main"
                        @click.prevent="savePayment"
                      >
                        Reportar pago
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import LTable from "src/components/Table.vue";
import moment from "moment";
import LoadImage from "../../../public/img/load_img.jpg";
import ObservationChat from "src/components/ObservationChat.vue";
import Cookies from "js-cookie";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    LTable,
    ObservationChat
      },
  data() {
    return {
      window_title: "Detalle del curso",
      description:
        "En esta vista puedes encontrar todo el detaller correspondiente al curso que seleccionaste para que puedas cerciorarte de que es el curso ideal para ti.",
      button_label: "Actualizar información",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      loading: true,

      id_user_logged: Cookies.get("id"),
      id_type_status: "",
      id_type_status_payment: "",
      id_user_platform: "",

      filesUser: [],
      selectorOpen: false,
      bcvRate: {},
      companyBank: [],
      banks_nationals: [],
      totalPaymentAmount: 0,
      amountWithDecimals: 0,
      idTmp: 0,
      listVisible: false,
      deleting: false,
      loaded: false,
      modalActiveUpdate: false,
      loadingData: true,

      user_data: {
        id: 0,
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        country: "",
      },

      form_payment: {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
        dni: "",
        phone: "",
        currency: "VES",
      },
      currencyOptions: [
        { code: "VES", name: "Bolívares (Bs)", symbol: "Bs." },
        { code: "USD", name: "Dólares ($)", symbol: "$" },
      ],

      form_save: {
        id_user_platform: "",
        name: "",
        url_file: "",
      },

      form_update: {
        id: 0,
        name: "",
        url: "",
        url_banner: "",
        url_image: "",
        description: "",
        autoapproved: "",
        params: "",
        amount: "",
        requires: "",
      },
      isExpanded: false,
      shouldShowToggle: false,
      isExpandedReq: false,
      shouldShowToggleReq: false,
      showYoutubeEmbed: false,
      states: [],
      cities: [],
      
      // Tabs y ofertas
      activeTab: "info",
      offers: [],
      loadingOffers: false,
      alreadyRegistered: false,
      existingUserPlatform: null,
      registrationAlertShown: false,
      selectedOfferId: null,
      selectedState: null,
    };
  },
  mounted() {
    this.getElement(this.$route.params.id);
    this.getStatus();
    this.loadImage();
    this.loadBanksNationals();
    this.loadstates();    
    this.$nextTick(() => {
      this.checkIfTruncated();
      this.checkIfTruncatedReq();
    });
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    isLoading() {
      if (this.loading) {
        return true;
      } else {
        return false;
      }
    },



    isBanner() {
      if (
        this.form_update.url_banner == "" ||
        this.form_update.url_banner == null ||
        this.form_update.url_banner == undefined
      ) {
        console.log("No hay imagen");
        return false;
      } else {
        console.log("Hay imagen");
        return true;
      }
    },
    presale1AmountFormatted() {
      if (!this.form_update.presale1_amount) return "";
      const value = Number(this.form_update.presale_1_amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    presale2AmountFormatted() {
      if (!this.form_update.presale2_amount) return "";
      const value = Number(this.form_update.presale_2_amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    amountFormatted() {
      if (!this.form_update.amount) return "";
      const value = Number(this.form_update.amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    bcvRateFormatted() {
      if (!this.bcvRate.value) return "";
      const value = Number(this.bcvRate.value);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    totalPaymentAmountFormatted() {
      if (!this.totalPaymentAmount) return "";
      const value = Number(this.totalPaymentAmount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    amountWithPrefix: {
      get() {
        const symbol = this.form_payment.currency === 'USD' ? '$' : 'Bs.';
        const locale = this.form_payment.currency === 'USD' ? 'en-US' : 'es-VE';
        return `${symbol} ${(this.form_payment.amount / 100).toLocaleString(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      set(newValue) {
        const value = newValue.replace(/[^0-9]/g, "");
        this.form_payment.amount = value;
        this.amountWithDecimals = parseFloat(value / 100).toFixed(2);
      },
    },
    maxPlacesFormatted() {
      if (!this.form_update.max_places) return "";
      const value = Number(this.form_update.max_places);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    hasLicenses() {
      return this.form_update.check_license_a || 
             this.form_update.check_license_b || 
             this.form_update.check_license_c || 
             this.form_update.check_license_d ||
             this.form_update.check_license_pro ||
             this.form_update.check_license_national ||
             this.form_update.check_license_regional;
    },
    getLicensesText() {
      const licenses = [];
      if (this.form_update.check_license_a) licenses.push('A');
      if (this.form_update.check_license_b) licenses.push('B');
      if (this.form_update.check_license_c) licenses.push('C');
      if (this.form_update.check_license_d) licenses.push('D');
      if (this.form_update.check_license_pro) licenses.push('Pro');
      if (this.form_update.check_license_national) licenses.push('Nacional');
      if (this.form_update.check_license_regional) licenses.push('Regional');
      return licenses.join(' ');
    },
    canPay() {
      return this.id_type_status == 3 && this.id_type_status_payment == 1;
    },
    statesWithOffers() {
      const allOption = { id: null, name: 'Todos' };
      
      if (!this.offers || this.offers.length === 0) {
        return [allOption];
      }

      const stateIdsInOffers = new Set();
      this.offers.forEach((offer) => {
        const stateId = offer.stateId || offer.state_id || offer.state;
        if (stateId) {
          stateIdsInOffers.add(Number(stateId));
        }
      });

      const filteredStates = this.states.filter((state) => stateIdsInOffers.has(Number(state.id)));
      return [allOption, ...filteredStates];
    },
    filteredOffers() {
      const sortByCityName = (list) => {
        return [...list].sort((a, b) => {
          const aName = (a?.cityName || "").toString().trim();
          const bName = (b?.cityName || "").toString().trim();

          if (!aName && !bName) return 0;
          if (!aName) return 1;
          if (!bName) return -1;

          return aName.localeCompare(bName, "es", { sensitivity: "base" });
        });
      };

      if (!this.selectedState || !this.selectedState.id || this.selectedState.id === null) {
        return sortByCityName(this.offers);
      }

      const selectedStateId = this.selectedState.id;
      const filtered = this.offers.filter((offer) => {
        // If the offer has a direct stateId/state_id, use it
        if (offer.stateId || offer.state_id) {
          const offerStateId = offer.stateId || offer.state_id;
          return offerStateId == selectedStateId || Number(offerStateId) === Number(selectedStateId);
        }

        // Fallback: match by stateName if available
        if (offer.stateName && this.selectedState.name) {
          return offer.stateName.toLowerCase() === this.selectedState.name.toLowerCase();
        }

        return true;
      });

      return sortByCityName(filtered);
    },
    registrationStatusText() {
      if (this.id_type_status === '' || this.id_type_status === 0) {
        return '';
      }
      
      if (this.id_type_status == 1) {
        return 'Postulación en revisión';
      }
      
      if (this.id_type_status == 2) {
        return 'Documentos rechazados';
      }
      
      if (this.id_type_status == 3) {
        if (this.id_type_status_payment == 1) {
          return 'Pendiente de pago';
        }
        if (this.id_type_status_payment == 2) {
          return 'Pago en revisión';
        }
        if (this.id_type_status_payment == 3) {
          return 'Inscrito';
        }
      }
      
      return '';
    },
    registrationStatusClass() {
      if (this.id_type_status == 1) {
        return 'bg-warning text-dark';
      }
      
      if (this.id_type_status == 2) {
        return 'bg-danger text-white';
      }
      
      if (this.id_type_status == 3) {
        if (this.id_type_status_payment == 1) {
          return 'bg-warning text-dark';
        }
        if (this.id_type_status_payment == 2) {
          return 'bg-info text-white';
        }
        if (this.id_type_status_payment == 3) {
          return 'bg-success text-white';
        }
      }
      
      return 'bg-secondary text-white';
    },
    getCurrentPaymentAmount() {
      if (!this.selectedOfferId) return 0;
      
      const selectedOffer = this.offers.find(offer => offer.id === this.selectedOfferId);
      if (!selectedOffer) return 0;
      
      const currentDate = new Date();
      
      // Check presale 1 dates
      if (selectedOffer.presale_1_start_date && selectedOffer.presale_1_end_date) {
        const presale1Start = new Date(selectedOffer.presale_1_start_date);
        const presale1End = new Date(selectedOffer.presale_1_end_date);
        
        if (currentDate >= presale1Start && currentDate <= presale1End) {
          return selectedOffer.presale_1_amount || selectedOffer.amount;
        }
      }
      
      // Check presale 2 dates
      if (selectedOffer.presale_2_start_date && selectedOffer.presale_2_end_date) {
        const presale2Start = new Date(selectedOffer.presale_2_start_date);
        const presale2End = new Date(selectedOffer.presale_2_end_date);
        
        if (currentDate >= presale2Start && currentDate <= presale2End) {
          return selectedOffer.presale_2_amount || selectedOffer.amount;
        }
      }
      
      // Return regular amount if not in any presale period
      return selectedOffer.amount;
    },
    currentAmountFormatted() {
      const amount = this.getCurrentPaymentAmount;
      if (!amount) return "";
      const value = Number(amount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  watch: {
    "form_update.description": function () {
      this.$nextTick(this.checkIfTruncated);
    },
    "form_update.requires": function () {
      this.$nextTick(this.checkIfTruncatedReq);
    },
  },
  methods: {
    ...mapActions([
      "getData",
      "updateData",
      "changeStatusData",
      "createData",
      "UserCreateDT",
    ]),

    getVideoEmbedUrl(url) {
      if (!url) return null;
      
      // YouTube
      const youtubeMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (youtubeMatch) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
      }
      
      // Vimeo
      const vimeoMatch = url.match(/(?:vimeo\.com\/)(\d+)/);
      if (vimeoMatch) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
      }
      
      return null;
    },

    loadBanksNationals() {
      let form = {
        url: "master/type_banks/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.banks_nationals = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    pizarraDT() {
      let form = {
        url: "user/user/myprofile",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.user_data = response.data;
            this.newUserDT();
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    newUserDT() {
      let data_form;
      data_form = {
        user_id: `${this.user_data.id}`,
        email: this.user_data.email,
        first_name: this.user_data.first_name,
        last_name: this.user_data.last_name,
        username: this.user_data.email,
        phone: this.user_data.phone,
        nationality: this.user_data.country
          ? this.user_data.country.name
          : "Venezuela",
        country_of_residence: this.user_data.country
          ? this.user_data.country.name
          : "Venezuela",
      };
      let form = {
        data: data_form,
      };

      this.UserCreateDT(form)
        .then((response) => {
          this.deleting = false;
          console.log(response);
          Swal.fire({
            title: "¡Bienvenid@ a Pizarra DT!",
            icon: "success",
            showConfirmButton: true,
            showLoaderOnConfirm: true,
          });
          window.open(
            "https://app.lapizarradeldt.com/auth/fvf?token=Bearer " +
              response.token,
            "_blank"
          );
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    openModalPayment() {
      console.log(this.form_update);
      // Asegurarnos de trabajar siempre con valores numéricos para la tasa BCV
      const numericBcv = Number(this.bcvRate.value) || 0;

      // Use the computed property to get the correct amount based on presale dates
      const rawAmount = this.getCurrentPaymentAmount;
      const numericAmount = parseFloat(rawAmount) || 0;

      // Guardamos solo el valor numérico; el formateo se hace en totalPaymentAmountFormatted
      this.totalPaymentAmount = numericAmount * numericBcv;
      console.log("OPEN PAYMENT MODAL - Amount:", rawAmount, "Total:", this.totalPaymentAmount);
      setTimeout(() => {
        const modalEl = document.getElementById("modalPayment");
        if (modalEl) {
          const modalInstance = Modal.getOrCreateInstance(modalEl);
          modalInstance.show();
        }
      }, 100);
      this.modalActiveUpdate = true;
    },

    closePaymentElement() {
      console.log("CLOSING PAYMENT MODAL");
      const modalEl = document.getElementById("modalPayment");
      if (modalEl) {
        const modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();
      }
      this.form_payment = {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
        dni: "",
        phone: "",
      };
      this.modalActiveUpdate = false;
    },

    savePayment() {
      const originBankValue =
        this.form_payment && typeof this.form_payment.origin_bank === "object"
          ? (this.form_payment.origin_bank?.name ||
              this.form_payment.origin_bank?.name_bank ||
              "")
          : (this.form_payment?.origin_bank || "");

      if (this.form_payment.id_company_bank == "") {
        Swal.fire({
          title: "Seleccione un banco",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (!originBankValue) {
        Swal.fire({
          title: "Ingrese el banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.date == "") {
        Swal.fire({
          title: "Seleccione la fecha del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.amount == 0) {
        Swal.fire({
          title: "Ingrese el monto pagado",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.reference == "") {
        Swal.fire({
          title: "Ingrese la referencia del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else {
        Swal.fire({
          title: "¿Estás seguro de reportar este pago?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sí, reportar",
        }).then((result) => {
          if (result.value) {
            let data_form;
            data_form = new FormData();
            data_form.append("id_user", this.id_user_logged);
            data_form.append("id_user_platform", this.id_user_platform);
            data_form.append(
              "id_company_bank",
              this.form_payment.id_company_bank.id
            );
            data_form.append("id_bcv_rate", this.bcvRate.id);
            data_form.append("reference", this.form_payment.reference);
            data_form.append("origin_bank", originBankValue);
            data_form.append("amount", this.amountWithDecimals);
            data_form.append(
              "date",
              new Date(this.form_payment.date).toISOString().slice(0, 10)
            );
            data_form.append("phone", this.form_payment.phone);
            data_form.append("currency", this.form_payment.currency);
            const filePondInstance = this.$refs.filePondPayment.getFiles();
            if (filePondInstance && filePondInstance.length > 0) {
              const file = filePondInstance[0].file;
              data_form.append("url_image", file);
            }
            let form = {
              url: "user/payment_report/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.closePaymentElement();
                  Swal.fire({
                    title: "Pago registrado correctamente",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  // location.reload(true);
                }
              })
              .catch((error) => {
                console.log(error);
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    showList() {
      this.listVisible = true;
    },

    handleOpenChange() {
      console.log("OPEN DATE SELECTOR");
      this.selectorOpen = true;
    },

    handleCloseChange() {
      console.log("CLOSE DATE SELECTOR");
      this.selectorOpen = false;
    },

    uploadFiles() {
      const filePondInstance = this.$refs.filePond.getFiles();
      if (filePondInstance && filePondInstance.length > 0) {
        Swal.fire({
          title: "Subiendo archivos...",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const promises = [];
        for (let i = 0; i < filePondInstance.length; i++) {
          let data_form;
          data_form = new FormData();
          const file = filePondInstance[i].file;
          const fileName = file.name;
          data_form.append("url_file", file);
          data_form.append("name", fileName);
          data_form.append("id_user_platform", this.id_user_platform);
          let form = {
            url: "user_file_platform/save",
            data: data_form,
          };
          promises.push(this.createData(form));
        }

        Promise.all(promises)
          .then((responses) => {
            // Handle success
            this.deleting = false;

            this.closeUploadElement();
            this.$router.push({ name: "Postulation" });
          })
          .catch((error) => {
            console.log(error);
            alert("Ocurrió un error, intente más tarde");
          })
          .finally(() => {
            Swal.close();
            Swal.fire({
              title: "Postulación enviada correctamente",
              text: "Ahora debes esperar a que respondan tu solicitud",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
          });
      }
    },

    openUploadElement() {
      console.log("OPEN UPLOAD MODAL");
      setTimeout(() => {
        const modalEl = document.getElementById("modalPostulation");
        if (modalEl) {
          const modalInstance = Modal.getOrCreateInstance(modalEl);
          modalInstance.show();
        }
      }, 100); // tiempo en milisegundos

      this.modalActiveUpdate = true;
    },

    closeUploadElement() {
      console.log("CLOSING UPLOAD MODAL");
      const modalEl = document.getElementById("modalPostulation");
      if (modalEl) {
        const modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();
      }
      this.modalActiveUpdate = false;
    },

    loadImage() {
      let image = new Image();
      image.src = this.form_update.url_banner;
      image.onload = () => {
        this.loading = false;
        console.log("Image loaded");
      };
      image.onerror = () => {
        this.loading = false;
        console.log("Image not loaded");
      };
    },

        markExistingRegistration(userPlatforms = []) {
      const user = Number(this.id_user_logged);
      if (!user || !Array.isArray(userPlatforms) || userPlatforms.length === 0) {
        return;
      }

      const existing = userPlatforms.find(
        (entry) => Number(entry.id_user) === user && Number(entry.id_platform) === Number(this.$route.params.id) && Number(entry.active) === 1
      );

      if (existing) {
        // Solo marcar como registrado si NO está rechazado (id_type_status != 2)
        if (existing.id_type_status != 2) {
          this.alreadyRegistered = true;
        } else {
          this.alreadyRegistered = false;
        }
        this.existingUserPlatform = existing;
      }
    },

    getElement(id) {
      this.loaded = false;
      this.loadingData = true;
      let data_params = {
        url: "user/platform/" + id,
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          this.form_update = response.data;
          this.markExistingRegistration(response.data.user_platforms);

          this.form_update.amount = parseFloat(this.form_update.amount).toFixed(
            2
          );
          this.form_update.amount = this.form_update.amount.toLocaleString(
            "es-VE",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          this.loaded = true;
          this.loadingData = false;
          
          // Cargar ofertas después de obtener la plataforma
          this.loadOffers(id);
        })
        .catch((error) => {
          this.loaded = true;
          this.loadingData = false;
          console.log(error);
        });
    },

    loadOffers(platformId) {
      this.loadingOffers = true;
      const params = {
        url: "platform_offer/all",
        params: {
          id_platform: platformId,
          active: 1,
          order_by: "id",
          order_value: "asc",
        },
      };

      this.getData(params)
        .then((response) => {
          this.loadingOffers = false;
          if (response.code === 200 && response.data && Array.isArray(response.data)) {
            this.offers = response.data.map((offer) => {
              const formatAmount = (v) => {
                if (!v) return "";
                const value = typeof v === "string" ? parseFloat(v) : v;
                if (isNaN(value)) return "";
                return value.toLocaleString("es-VE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
              };

              const formatQuantity = (v) => {
                if (!v) return "";
                const value = typeof v === "string" ? parseInt(v, 10) : v;
                if (isNaN(value)) return "";
                return value.toLocaleString("es-VE", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
              };

              const now = new Date();
              let priceType = "Monto regular";

              // Calcular monto efectivo según preventas
              const baseAmount = Number(offer.amount || 0);
              let effectiveAmount = baseAmount;

              if (offer.presale_1_start_date && offer.presale_1_end_date) {
                const p1Start = new Date(offer.presale_1_start_date);
                const p1End = new Date(offer.presale_1_end_date);
                if (
                  now >= p1Start &&
                  now <= p1End &&
                  Number(offer.presale_1_amount || 0) > 0
                ) {
                  priceType = "Preventa 1";
                  effectiveAmount = Number(offer.presale_1_amount || baseAmount);
                }
              }

              if (offer.presale_2_start_date && offer.presale_2_end_date) {
                const p2Start = new Date(offer.presale_2_start_date);
                const p2End = new Date(offer.presale_2_end_date);
                if (
                  now >= p2Start &&
                  now <= p2End &&
                  Number(offer.presale_2_amount || 0) > 0
                ) {
                  priceType = "Preventa 2";
                  effectiveAmount = Number(offer.presale_2_amount || baseAmount);
                }
              }

              // Buscar nombre del estado
              const state = this.states.find((s) => s.id === offer.state || s.id === parseInt(offer.state));
              const stateName = state ? state.name : "Venezuela";
              
              // Buscar nombre de la ciudad con validación
              let cityName = "Venezuela";
              if (offer.city && offer.city !== 0) {
                if (offer.city_relation && offer.city_relation.name) {
                  cityName = offer.city_relation.name;
                } else {
                  const city = this.cities.find((c) => c.id === offer.city || c.id === parseInt(offer.city));
                  cityName = city ? city.name : "Venezuela";
                }
              }
              
              return {
                id: offer.id,
                amount: effectiveAmount,
                amountFormatted: formatAmount(effectiveAmount),
                quantity: offer.quantity,
                quantityFormatted: formatQuantity(offer.quantity),
                stateId: offer.state,
                stateName: stateName,
                cityId: offer.city,
                cityName: cityName,
                priceType,
                presale1: offer.presale1_amount > 0 ? "1" : "0",
                presale1_amount: offer.presale1_amount || 0,
                presale1_amountFormatted: formatAmount(offer.presale1_amount),
                presale1_places: offer.presale1_places || 0,
                presale1_placesFormatted: formatQuantity(offer.presale1_places),
                presale2: offer.presale2_amount > 0 ? "1" : "0",
                presale2_amount: offer.presale2_amount || 0,
                presale2_amountFormatted: formatAmount(offer.presale2_amount),
                presale2_places: offer.presale2_places || 0,
                presale2_placesFormatted: formatQuantity(offer.presale2_places),
              };
            });
          } else {
            this.offers = [];
          }
        })
        .catch((error) => {
          this.loadingOffers = false;
          console.warn("Error cargando ofertas:", error);
          this.offers = [];
        });
    },

    selectOffer(offerId) {
      this.selectedOfferId = offerId;
    },

    getStatus() {
      let data_params = {
        url: "user/user_platform/all",
        params: {
          active: 1,
          // id_user: this.id_user_logged,
          id_platform: this.$route.params.id,
          order_by: "id",
          order_value: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            if (response.data.length > 0) {
              this.id_type_status = response.data[0].id_type_status;
              this.id_type_status_payment =
                response.data[0].id_type_status_payment;
              this.id_user_platform = response.data[0].id;
              
              // Set the selected offer when user is already registered
              if (response.data[0].id_platform_offer) {
                this.selectedOfferId = response.data[0].id_platform_offer;
              }
              
              // Marcar como registrado según el estado
              // Solo permitir nueva postulación si está rechazado (2) o no tiene postulación (0)
              if (this.id_type_status == 2 || this.id_type_status == 0) {
                this.alreadyRegistered = false;
              } else {
                // Estados 1 (pendiente) y 3 (aprobado) no permiten nueva postulación
                this.alreadyRegistered = true;
              }
              
              this.loadUserFiles(this.id_user_platform);
              if (this.id_type_status == 3) {
                this.loadBcvRate();
                this.loadCompanyBank();
              }
            } else {
              this.id_type_status = 0;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadBcvRate() {
      let data_params = {
        url: "bcv_rate/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.bcvRate = response.data[0];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCompanyBank() {
      let data_params = {
        url: "user/company_bank/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "asc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.companyBank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadUserFiles(id_user_platform) {
      if (this.id_type_status != 3) {
        let data_params = {
          url: "user_file_platform/all",
          params: {
            active: 1,
            id_user_platform: id_user_platform,
            order_by: "id",
            order_value: "asc",
          },
        };

        this.getData(data_params)

          .then((response) => {
            if (response.code == 200) {
              this.filesUser = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    deleteFile(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este archivo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#048224ff",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar",
      }).then((result) => {
        if (result.value) {
          let data_form;
          data_form = {
            active: 2,
          };
          let form = {
            url: "user_file_platform/update",
            id: id,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserFiles(this.id_user_platform);
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },

    returnUrl() {
      this.$router.go(-1);
    },

    postulateMe() {
      // Permitir re-postulación si está rechazado (id_type_status == 2)
      if (this.alreadyRegistered && this.id_type_status != 2) {
        Swal.fire({
          icon: "info",
          title: "Ya estás inscrito",
          text: "Ya tienes una postulación activa para este curso.",
          confirmButtonText: "Entendido",
        });
        return;
      }
      if (this.form_update.autoapproved == 0) {
        const selectedOffer = this.offers.find(
          (offer) => offer.id === this.selectedOfferId
        );
        const cityName = selectedOffer
          ? selectedOffer.cityName || "Venezuela"
          : "";

        Swal.fire({
          title: "¡Atención!",
          text:
            "¿Estás seguro de postularte a " +
            this.form_update.name +
            (cityName ? " en " + cityName : "") +
            "?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, continuar",
        }).then((result) => {
          if (result.value) {
            let data_form;

            // Si está rechazado, actualizar el registro existente
            if (this.id_type_status == 2 && this.id_user_platform) {
              data_form = {
                id: this.id_user_platform,
                id_user: this.id_user_logged,
                id_platform: this.form_update.id,
                id_platform_offer: this.selectedOfferId,
                id_type_status: 1, // Cambiar a "en revisión"
              };
            } else {
              data_form = {
                id_user: this.id_user_logged,
                id_platform: this.form_update.id,
                id_platform_offer: this.selectedOfferId,
              };
            }

            this.deleting = true;
            let form = {
              // url: "user_platform/save",
              url: "user/user_platform/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200 && response.status === 'OK') {
                  this.deleting = false;
                  Swal.fire({
                    title: "Postulación enviada correctamente",
                    text: "Ahora debes esperar a que respondan tu solicitud",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });

                  this.$router.push({ name: "Overview" });
                } else {
                  this.deleting = false;
                  Swal.fire({
                    title: "No se pudo realizar la postulación",
                    text: response.message || "Ocurrió un error al procesar tu solicitud",
                    icon: "error",
                    confirmButtonText: "Entendido",
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }

      if (this.form_update.autoapproved == 1) {
        let data_form;

        data_form = {
          id_user: this.id_user_logged,
          id_platform: this.form_update.id,
          id_type_status: 3,
          id_type_status_payment: 3,
        };

        this.deleting = true;
        let form = {
          // url: "user_platform/save",
          url: "user/user_platform/save",
          data: data_form,
        };
        this.createData(form)
          .then((response) => {
            if (response.code === 200 && response.status === 'OK') {
              this.deleting = false;
              Swal.fire({
                title: "¡Bienvenido al curso!",
                text: "Ahora puedes acceder al curso",
                icon: "success",
                showConfirmButton: false,
                showLoaderOnConfirm: true,
                timer: 1000,
              });

              this.$router.push({ name: "Overview" });
            } else {
              this.deleting = false;
              Swal.fire({
                title: "No se pudo realizar la inscripción",
                text: response.message || "Ocurrió un error al procesar tu solicitud",
                icon: "error",
                confirmButtonText: "Entendido",
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.deleting = false;
            alert("Ocurrió un error, intente más tarde");
          });
      }
    },
    formatDate(date) {
      if (!date) return "";

      // Si ya es moment
      if (moment.isMoment(date)) {
        return date.format("DD-MM-YYYY");
      }

      // Si es Date
      if (date instanceof Date) {
        return moment(date.toISOString()).format("DD-MM-YYYY");
      }

      // Si es string tipo "Wed Jun 18 2025 00:00:00 GMT-0400 (hora de Venezuela)"
      if (typeof date === "string") {
        const iso = this.toISODateString(date);
        if (iso) {
          return moment(iso).format("DD-MM-YYYY");
        }
      }

      return "";
    },
    toISODateString(dateString) {
      // Intenta crear un objeto Date con el string recibido
      const d = new Date(dateString);
      if (!isNaN(d.getTime())) {
        return d.toISOString();
      }
      return null;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    checkIfTruncated() {
      const desc = this.$refs.desc;
      if (desc) {
        this.shouldShowToggle = desc.scrollHeight > 120;
      }
    },
    toggleExpandReq() {
      this.isExpandedReq = !this.isExpandedReq;
    },
    checkIfTruncatedReq() {
      const reqDesc = this.$refs.reqDesc;
      if (reqDesc) {
        this.shouldShowToggleReq = reqDesc.scrollHeight > 120;
      }
    },
    formatRequiresText(text) {
      if (!text) return "";
      return text.replace(/(\r\n|\n|\r)/g, "<br>");
    },
    formatDescriptionText(text) {
      if (!text) return "";
      return text.replace(/(\r\n|\n|\r)/g, "<br>");
    },
    getYoutubeId(url) {
      if (!url) return "";
      // Soporta múltiples formatos de YouTube
      const regExp =
        /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
      const match = url.match(regExp);
      const id = match ? match[1] : null;
      console.log("YouTube URL:", url, "ID extraído:", id);
      return id;
    },
    playYoutubeEmbed() {
      this.showYoutubeEmbed = true;
    },
    loadstates() {
      let data_params = {
        url: "master/state/all",
        params: {
          active: 1,
          id_country: 239,
          order_key: "name",
          order_value: "asc",
        },
      };
      this.getData(data_params)
        .then((response) => {
          if (response.code == 200) {
            this.states = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStateName(id) {
      const state = this.states.find((c) => c.id == id || c.id == Number(id));
      return state ? state.name : id;
    },

    accessPlatform() {
      if (!this.id_user_platform) {
        Swal.fire({
          title: "Error",
          text: "No se encontró la información de tu inscripción",
          icon: "error",
          confirmButtonText: "Entendido",
        });
        return;
      }

      Swal.fire({
        title: "Obteniendo acceso...",
        text: "Por favor espera",
        icon: "info",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let data_params = {
        url: `user/user_platform/access/${this.id_user_platform}`,
        params: {},
      };

      this.getData(data_params)
        .then((response) => {
          Swal.close();
          if (response.code === 200 && response.data) {
            if (response.data.status !== "AVAILABLE") {
              Swal.fire({
                title: "Acceso no disponible",
                text: "Aún no has sido aprobado para acceder a la plataforma",
                icon: "warning",
                confirmButtonText: "Entendido",
              });
            } else if (response.data.url) {
              window.open(response.data.url, "_blank");
            } else {
              Swal.fire({
                title: "Error",
                text: "No se pudo obtener el enlace de acceso",
                icon: "error",
                confirmButtonText: "Entendido",
              });
            }
          } else {
            Swal.fire({
              title: "Error",
              text: "No se pudo obtener el enlace de acceso",
              icon: "error",
              confirmButtonText: "Entendido",
            });
          }
        })
        .catch((error) => {
          Swal.close();
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error al obtener el enlace de acceso",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        });
    },
  },
};
</script>

<style>
.loader {
  display: flex;
  justify-content: center;
  height: 300px;
}

.loader-icon {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6d263a;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #b49b57;
  border-color: #b49b57;
}

.filepond--drop-label.filepond--drop-label label {
  text-align: center !important;
  color: black !important;
  font-size: small;
}

.btn-invert {
  border-radius: 30px;
  padding: 0.7rem 2rem;
  border: none;
  background-color: #b49b57;
  color: rgb(53, 16, 32);
}

.btn-invert:hover {
  transition-duration: 0.1s;
  transform: scale(1.05);
  box-shadow: 0 2px 2px 1px #b49b57;
}
</style>
<style scoped>
/* Define la altura máxima y permite el desplazamiento */
.scrollable {
  max-height: 400px;
  overflow-y: auto;
}
.user-header {
  font-weight: bold;
  font-size: 15.6px;
}
.user-row {
  font-size: 15.6px;
}

.start-date,
.course-duration,
.max-places {
  border: 1px solid white;
  border-radius: 1rem;
  padding: 0.3rem 0.7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.start-date > div:first-child,
.start-date > div:nth-child(2) {
  font-size: 1.1rem;
  opacity: 0.8;
}

.course-duration > div:first-child {
  font-size: 1.1rem;
  opacity: 0.8;
}

.max-places > div:first-child {
  font-size: 1.1rem;
  opacity: 0.8;
}

.text-responsive {
  font-size: clamp(0.5rem, 2vw + 0.5rem, 1rem);
}

.text-title-responsive {
  font-size: clamp(0.6rem, 2vw + 0.5rem, 1.3rem);
}

.essential-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
}

.type_plattform,
.url-platform,
.requirements {
  border: 1px solid white;
  border-radius: 1rem;
  padding: 0.3rem 0.7rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.first-presale,
.second-presale,
.type-status {
  background: linear-gradient(135deg, #6d263a 60%, #a14e5a 100%);
  border-radius: 1.5rem;
  color: #fff;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  min-width: 220px;
  max-width: 100%;
  margin: 0 auto;
}
.presale-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.7rem;
  letter-spacing: 1px;
}
.presale-dates,
.type-status-title {
  font-size: 1.1rem;
  margin-bottom: 1.2rem;
  opacity: 0.85;
}
.presale-price-box,
.sale-price-box,
.current-status-box {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 1rem;
  padding: 0.7rem 0;
  margin-bottom: 1.2rem;
}
.presale-price-box,
.sale-price-box > div:first-child {
  font-size: 1.1rem;
  opacity: 0.8;
}
.presale-price .sale-price .current-status .requirements-title .url-title {
  font-size: 1.7rem;
  font-weight: bold;
  margin-top: 0.2rem;
  letter-spacing: 1px;
}
.presale-city {
  font-size: 1.1rem;
  opacity: 0.85;
}
.general-info-card {
  background: linear-gradient(135deg, #6d263a 60%, #a14e5a 100%);
  border-radius: 1.5rem;
  color: #fff;
  padding: 1.5rem 1.2rem 1.2rem 1.2rem;
  margin-top: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  min-width: 270px;
  position: relative;
  overflow: hidden;
}
.general-info-header .general-info-body {
  font-size: 1.1rem;
}
/* .general-info-details {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  opacity: 0.85;
} */
.apply-btn {
  background: linear-gradient(90deg, #ff9800 60%, #ff5722 100%);
  color: #fff;
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 2.2rem;
  font-weight: bold;
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.18);
  cursor: pointer;
  transition: background 0.2s;
}
.apply-btn:hover {
  background: linear-gradient(90deg, #ffb74d 60%, #ff7043 100%);
}
.soccer-ball {
  width: 48px;
  height: 48px;
  margin-left: 1.2rem;
  margin-bottom: -0.5rem;
}

/* Contenedor principal sin padding */
.platform-view-container {
  padding: 0;
  margin: 0;
  width: 100%;
}

.loader-wrapper {
  padding: 2rem;
}

.course-detail {
  background: transparent;
  margin: 0;
  padding: 0;
  border-radius: 0;
}

/* Botón Volver dentro del banner */
.btn-volver {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  border-radius: 20px;
}

h1,
h2,
h3,
h4,
h5,
h6,
span {
  color: #fff;
}

.general-info-card.position-relative {
  position: relative;
}
.sale-price-box.position-absolute {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  z-index: 2;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 1rem;
  padding: 0.7rem 1.2rem;
  min-width: 90px;
  text-align: center;
}
.banner-card-header {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  border-radius: 0;
}
.banner-card-header img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: top;
  display: block;
}
.btn-banner-top-right {
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 10;
}
.banner-gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  border-radius: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.3) 100%
  );
  z-index: 2;
}
.description-wrapper {
  position: relative;
  width: 100%;
}
.course-description.collapsed {
  max-height: 122px;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s;
  margin-bottom: 0;
}
.longe-text {
  display: block;
  color: #615f5f;
  cursor: pointer;
  text-align: right;
  margin-bottom: 0;
}
.requirements-wrapper {
  position: relative;
  width: 100%;
}
.requirements-text.collapsed {
  max-height: 124px;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s;
  margin-bottom: 0;
}

/* MODAL PAYMENT REPORT custom styles */
.custom-modal-payment .modal-dialog {
  max-width: 600px;
  min-height: 600px;
}

.custom-modal-payment .modal-content {
  border-radius: 22px;
  box-shadow: 0 8px 32px rgba(53, 16, 32, 0.18);
  background: #6d263a;
  padding: 0;
  border: none;
}

.payment-information-header {
  border-top-left-radius: 44px;
  border-top-right-radius: 44px;
}

.custom-modal-payment .custom-header {
  background: #6d263a;
  color: #fff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  padding: 1.5rem 1rem 1rem 1rem;
  position: relative;
}

.custom-modal-payment .modal-body {
  background: #fff;
  border-bottom-left-radius: 22px;
  border-bottom-right-radius: 22px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.custom-modal-payment .modal-title {
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 1px;
}
.custom-modal-payment .custom-close {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  color: #fff;
  font-size: 2rem;
  background: none;
  border: none;
  opacity: 1;
}

.custom-modal-payment .btn.custom-btn-main {
  background: #6d263a;
  color: #fff;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.8rem 0;
  width: 100%;
  box-shadow: 0 2px 8px rgba(109, 38, 58, 0.08);
  transition: background 0.2s;
}
.custom-modal-payment .btn.custom-btn-main:hover {
  background: #a14e5a;
}

/* Platform content wrapper con fondo */
.platform-content-wrapper {
  background-image: url('/public/img/background_platform.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 10px;
}

.tab-btn {
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:hover,
.tab-btn.active {
  background: #b49b57;
  border-color: #b49b57;
}

/* Tab Ciudades */
.tab-ciudades {
  min-height: 400px;
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* Cities Grid */
.cities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.city-card {
  background: linear-gradient(135deg, #6d263a 60%, #a14e5a 100%);
  border-radius: 1.5rem;
  padding: 1.5rem;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.city-card:hover {
  border-color: rgba(180, 155, 87, 0.5);
}

.city-card-selected {
  border-color: #b49b57;
  background: linear-gradient(135deg, #7d3349 60%, #b15e6a 100%);
}

/* Botón Golden */
.btn-golden {
  background-color: #b49b57;
  border-color: #b49b57;
  border-radius: 20px;
  padding: 8px 24px;
  font-weight: 600;
  color: #1a1a1a;
  transition: all 0.3s ease;
}

.btn-golden:hover {
  background-color: #d1b25d;
  border-color: #d1b25d;
  color: #1a1a1a;
}

.btn-golden:disabled {
  background-color: #b7b7b7;
  border-color: #b7b7b7;
  color: #666;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Botón Golden con animación hover elegante */
.btn-golden-hover {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #b49b57;
  border: none;
  border-radius: 50px;
  padding: 6px;
  font-weight: 600;
  color: #1a1a1a;
  overflow: hidden;
  min-width: 180px;
  height: 48px;
  transition: background-color 0.3s ease;
}

.btn-golden-hover:hover:not(:disabled) {
  background-color: #d1b25d;
}

.btn-golden-hover:disabled {
  background-color: #b7b7b7;
  color: #666;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-golden-hover .btn-icon-circle {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #fff;
  color: #1a1a1a;
  border-radius: 50%;
  font-size: 18px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  right: 6px;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), right 0.5s cubic-bezier(0.4, 0, 0.2, 1), left 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-golden-hover:hover:not(:disabled) .btn-icon-circle {
  right: auto;
  left: 6px;
}

.btn-golden-hover .btn-text-label {
  white-space: nowrap;
  color: #1a1a1a;
  margin-left: 12px;
  margin-right: 48px;
  transition: margin 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-golden-hover:hover:not(:disabled) .btn-text-label {
  margin-left: 48px;
  margin-right: 12px;
}

.btn-golden-hover .icon-initial,
.btn-golden-hover .icon-hover {
  position: absolute;
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.btn-golden-hover .icon-initial {
  opacity: 1;
  transform: rotate(0deg);
}

.btn-golden-hover .icon-hover {
  opacity: 0;
  transform: rotate(-90deg);
}

.btn-golden-hover:hover:not(:disabled) .icon-initial {
  opacity: 0;
  transform: rotate(90deg);
}

.btn-golden-hover:hover:not(:disabled) .icon-hover {
  opacity: 1;
  transform: rotate(0deg);
}

.btn-golden-hover:disabled .btn-icon-circle {
  background-color: #e0e0e0;
  color: #999;
}

.city-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.city-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.city-detail-item {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  padding: 8px 16px;
  color: #fff;
  font-size: 0.9rem;
}

.city-detail-item span {
  color: #fff;
}

/* Loader icon para tab ciudades */
.loader-icon.mx-auto {
  margin: 0 auto;
}

/* Tab Info Styles */
.tab-info {
  color: #fff;
}

.platform-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.platform-description {
  font-size: 0.95rem;
  line-height: 1.6;
  opacity: 0.9;
}

.info-input {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 12px 16px;
  color: #fff;
  font-size: 0.9rem;
  min-height: 48px;
  display: flex;
  align-items: center;
}

.info-input-multiline {
  flex-direction: column;
  align-items: flex-start;
  min-height: auto;
}

.info-label {
  color: #fff;
  font-size: 0.9rem;
}

.video-container {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16/9;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.video-player {
  width: 100%;
  height: 100%;
}

.video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.video-icon {
  font-size: 64px;
  color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 768px) {
  .cities-grid {
    grid-template-columns: 1fr;
  }
  
  .tab-btn {
    padding: 6px 16px;
    font-size: 0.75rem;
  }

  .platform-title {
    font-size: 1.5rem;
  }

  .video-container {
    margin-top: 1rem;
  }
}




.btn-fvf-access {
  background: linear-gradient(135deg, #500e22 0%, #8D1B3D 50%, #500e22 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 15px rgba(112, 19, 47, 0.4);
}

/* Lava Background Effect */
.btn-fvf-access::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: 
    radial-gradient(circle at 50% 50%, rgba(197, 160, 89, 0.2) 0%, transparent 20%),
    radial-gradient(circle at 10% 20%, rgba(197, 160, 89, 0.15) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 15%);
  background-size: 50% 50%, 60% 60%, 50% 50%;
  animation: lava-flow 10s ease-in-out infinite alternate;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.btn-fvf-access:hover::before {
  opacity: 1;
}

@keyframes lava-flow {
  0% { transform: rotate(0deg) translate(0, 0); }
  33% { transform: rotate(5deg) translate(10px, 10px); }
  66% { transform: rotate(-5deg) translate(-10px, 5px); }
  100% { transform: rotate(0deg) translate(0, 0); }
}

.btn-fvf-access:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(197, 160, 89, 0.4);
  color: #fff;
}

.btn-fvf-access:active {
  transform: translateY(1px);
}

/* Span Animations for the Border Snake Effect - SLOWER (2s cycle) */
.btn-fvf-access span:nth-child(1),
.btn-fvf-access span:nth-child(2),
.btn-fvf-access span:nth-child(3),
.btn-fvf-access span:nth-child(4) {
  position: absolute;
  display: block;
}

/* Top Border */
.btn-fvf-access span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #C5A059);
  animation: btn-anim1 2s linear infinite;
}
@keyframes btn-anim1 {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

/* Right Border */
.btn-fvf-access span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #C5A059);
  animation: btn-anim2 2s linear infinite;
  animation-delay: 0.5s;
}
@keyframes btn-anim2 {
  0% { top: -100%; }
  50%, 100% { top: 100%; }
}

/* Bottom Border */
.btn-fvf-access span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 3px;
  background: linear-gradient(270deg, transparent, #C5A059);
  animation: btn-anim3 2s linear infinite;
  animation-delay: 1s;
}
@keyframes btn-anim3 {
  0% { right: -100%; }
  50%, 100% { right: 100%; }
}

/* Left Border */
.btn-fvf-access span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #C5A059);
  animation: btn-anim4 2s linear infinite;
  animation-delay: 1.5s;
}
@keyframes btn-anim4 {
  0% { bottom: -100%; }
  50%, 100% { bottom: 100%; }
}



</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
